

export const ResearchLinks = [
    {name:'Submit',path:'/research-submit'},
    {name:'Research',path:'/researches'},
    {name:'Authors',path:'/authors'},
    {name:'Affiliations',path:'/affiliations'},
    {name:'Themes',path:'/themes'},
]
export const PublicationLinks = [
    {name:'Submit',path:'/submit-publications'},
    {name:'Publications',path:'/publications'},
]

export const ProjectsLinks = [
    {name:'Submit',path:'/project-submit'},
    {name:'Projects',path:'/projects'},
]

export const ProductsLinks = [
    {name:'Submit',path:'/product-submit'},
    {name:'Products',path:'/products'},
]

export const MoreLinks = [
    // {name:'Contact Us',path:'/contact-us'},
    {name:'Resources',path:'/general-resources'},
    {name:'Testimonials',path:'/testimonials'},
    {name:'Feedbacks',path:'/feedback'},

]